import { Injectable } from '@angular/core';
import { User as AuthenticatedUser } from 'shared/services/authenticatedUser/types';
import { OrganizationType, Plan } from 'shared/services';
import { ApiModel } from './api.model';
import { ManufacturerPrivilege, RetailerPrivilege } from 'helpers/team-user-roles';

@Injectable()
export class AdminModel {
    constructor(private apiModel: ApiModel) {}

    getUsers(): Promise<InternalUserObject[]> {
        return this.apiModel.makeHttpRequest({
            method: 'GET',
            url: `${this.apiModel.getUsersEndpoint()}`
        });
    }

    changeBlockedStatus(username: string, blocked: boolean): Promise<any> {
        return this.apiModel.makeHttpRequest({
            method: 'PUT',
            url: `${this.apiModel.getUsersEndpoint()}/blocked`,
            body: { username, blocked }
        });
    }

    changeOrganizationPlan(organizationId, plan): Promise<any> {
        return this.apiModel.makeHttpRequest({
            method: 'PUT',
            url: `${this.apiModel.getOrganizationsEndpoint()}/${organizationId}/plan`,
            body: { plan }
        });
    }

    activateAccount(userId): Promise<any> {
        return this.apiModel.makeHttpRequest({
            method: 'POST',
            url: `${this.apiModel.getUsersEndpoint()}/action/activateAccount`,
            body: { _id: userId }
        });
    }

    adminAccess(email: string, organizationId: string): Promise<AuthenticatedUser> {
        return this.apiModel.makeHttpRequest({
            method: 'POST',
            url: `${this.apiModel.getSigninEndpoint()}/adminAccess`,
            body: { email, organizationId },
            withCredentials: true
        });
    }

    setEcommercePackage(organizationId: string, packageValue: boolean) {
        return this.apiModel.makeHttpRequest({
            method: 'PUT',
            url: `${this.apiModel.getOrganizationsEndpoint()}/${organizationId}/packages`,
            body: {
                package: 'ecommerce',
                value: packageValue
            }
        });
    }
}

export interface InternalUserObject {
    _id: string;
    email: string;
    emailVerified: boolean;
    type: OrganizationType;
    created: string;
    blocked: boolean;
    firstname: string;
    surname: string;
    privileges: ManufacturerPrivilege[] | RetailerPrivilege[];
    organization: {
        _id: string;
        name: string;
        plan: Plan;
        phone: string;
        type: OrganizationType;
        hasEcommercePackage: boolean;
    };
}
